import { AppRoutes } from './models';

const routes: AppRoutes = {
	home: {
		pathname: '/',
		fullPath: '/',
		name: 'Home',
	},
	changePassword: {
		pathname: '/change-password',
		fullPath: '/change-password',
		name: 'Change Password',
	},
	dashboard: {
		pathname: 'dashboard',
		fullPath: '/dashboard',
		name: 'Dashboard',
	},
	divisions: {
		pathname: 'divisions',
		fullPath: '/divisions',
		name: 'Divisions',
	},
	archivedProjects: {
		pathname: 'archived',
		fullPath: '/dashboard/archived',
		name: 'Archive',
		icon: 'archive-fill',
	},
	internalUserDashboard: {
		pathname: 'internal',
		fullPath: '/dashboard/internal',
		name: 'Dashboard',
		icon: 'grid-1x2-fill',
	},
	inspectionTracker: {
		pathname: 'general-report-overview',
		fullPath: '/dashboard/general-report-overview',
		name: 'Inspection Tracker',
		icon: 'cone-striped',
	},
	externalUserDashboard: {
		pathname: 'external',
		fullPath: '/dashboard/external',
		name: 'Dashboard',
		icon: 'grid-1x2-fill',
	},
	dashboardWildCard: {
		pathname: 'dashboard/*',
		fullPath: '/dashboard/*',
		name: 'Dashboard Wildcard',
	},
	projects: {
		pathname: 'projects',
		fullPath: '/dashboard/projects',
		icon: 'kanban-fill',
		name: 'All Projects',
	},
	organizationDashboard: {
		pathname: 'my-projects',
		fullPath: '/dashboard/my-projects',
		icon: 'kanban',
		name: 'Inspection Report',
	},
	notifications: {
		pathname: 'notifications',
		fullPath: '/dashboard/notifications',
		icon: 'bell-fill',
		name: 'Notifications',
	},
	projectDetails: {
		pathname: 'projects/:projectId',
		fullPath: '/dashboard/projects/:projectId',
		name: 'Project Details',
	},
	projectProgress: {
		pathname: 'projects/:projectId/progress',
		fullPath: '/dashboard/projects/:projectId/progress',
		name: 'Project Progress Report',
	},
	newReport: {
		pathname: 'projects/:projectId/new-report',
		fullPath: '/dashboard/projects/:projectId/new-report',
		name: 'New Report',
	},
	organizations: {
		pathname: 'organizations',
		fullPath: '/dashboard/organizations',
		icon: 'building',
		name: 'Organizations',
	},
	organizationDetails: {
		pathname: 'organizations/:organizationId',
		fullPath: '/dashboard/organizations/:organizationId',
		icon: 'building',
		name: 'Organization Details',
	},
	tutorials: {
		pathname: 'tutorials',
		fullPath: '/dashboard/tutorials',
		icon: 'sign-stop-lights-fill',
		name: 'Tutorials',
	},
	unauthorized: {
		pathname: 'unauthorized',
		fullPath: '/dashboard/unauthorized',
		icon: 'sign-stop-fill',
		name: 'Unauthorized',
	},
	users: {
		pathname: 'users',
		fullPath: '/dashboard/users',
		icon: 'person-bounding-box',
		name: 'Users',
	},
	userDetails: {
		pathname: 'users/:userId',
		fullPath: '/dashboard/users/:userId',
		name: 'User Details',
	},
	addRole: {
		pathname: 'add-role',
		fullPath: '/dashboard/add-role',
		name: 'Add Role',
		icon: 'card-heading',
	},
	profileSettings: {
		pathname: 'profile-settings',
		fullPath: '/dashboard/profile-settings',
		icon: 'gear-fill',
		name: 'Profile Settings',
	},
	login: {
		pathname: 'login',
		fullPath: '/login',
		name: 'Login',
	},
	logout: {
		pathname: 'logout',
		fullPath: '/logout',
		icon: 'door-closed-fill',
		name: 'Logout',
	},
	wildcard: {
		pathname: '*',
		fullPath: '*',
		name: 'Wildcard',
	},
	baseUrl: {
		pathname: '/',
		fullPath: '/',
		name: 'Base Url',
	},
	forgotPassword: {
		pathname: 'forgot-password',
		fullPath: '/forgot-password',
		name: 'Forgot Password',
	},
	reportUpload: {
		pathname: 'report-upload',
		fullPath: '/dashboard/report-upload',
		name: 'Report Upload'
	}
};

export default Object.freeze(routes);
